import { relations } from 'drizzle-orm'
import { boolean, index, integer, pgTable, real, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { tenants } from './tenants'

// Trainings
export const trainings = pgTable(
  'trainings',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    title: text('title').notNull(),
    description: text('description'),
    trainingType: text('training_type').notNull(),
    category: text('category'),
    tags: text('tags').array().default([]),
    capacity: integer('capacity'),
    standardDurationHours: real('standard_duration_hours'),
    guideFileUrl: text('guide_file_url'),
    notificationChannel: text('notification_channel'),
    hrContactEmail: text('hr_contact_email'),
    // 評価シートに表示するスキルチェックの補足（評価の目安など）
    skillCheckNote: text('skill_check_note'),
    isPublished: boolean('is_published').default(false).notNull(),
    isDeleted: boolean('is_deleted').default(false).notNull(),
    deletedAt: timestamp('deleted_at'),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    createdAt: timestamp('created_at').defaultNow().notNull(),
    updatedAt: timestamp('updated_at').defaultNow().notNull(),
  },
  (table) => ({
    tenantIdIdx: index('trainings_tenant_id_idx').on(table.tenantId),
    tenantTypeIdx: index('trainings_tenant_type_idx').on(table.tenantId, table.trainingType),
  }),
)

// Training Schedules
export const trainingSchedules = pgTable(
  'training_schedules',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    trainingId: uuid('training_id')
      .notNull()
      .references(() => trainings.id, { onDelete: 'cascade' }),
    scheduleDate: timestamp('schedule_date').notNull(),
    endDate: timestamp('end_date'),
    location: text('location'),
    dayNumber: integer('day_number').notNull(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    createdAt: timestamp('created_at').defaultNow().notNull(),
  },
  (table) => ({
    trainingIdIdx: index('training_schedules_training_id_idx').on(table.trainingId),
    tenantIdIdx: index('training_schedules_tenant_id_idx').on(table.tenantId),
  }),
)

// Relations
export const trainingsRelations = relations(trainings, ({ many }) => ({
  trainingSchedules: many(trainingSchedules),
}))

export const trainingSchedulesRelations = relations(trainingSchedules, ({ one }) => ({
  training: one(trainings, {
    fields: [trainingSchedules.trainingId],
    references: [trainings.id],
  }),
}))

// Type exports
export type Training = typeof trainings.$inferSelect
export type NewTraining = typeof trainings.$inferInsert

export type TrainingSchedule = typeof trainingSchedules.$inferSelect
export type NewTrainingSchedule = typeof trainingSchedules.$inferInsert
